import React from 'react';
import { useSelector } from 'react-redux';
import CreateMemo from 'Modules/CreateMemo';
import ReferralMemo from 'Modules/ReferralMemo/ReferralMemo';
import { PrescriptionModal } from 'Modules/Prescription';
import MCWrapper from 'Modules/MedicalCertificate/MCWrapper';
import POS from 'Modules/POS/POS';
import ConfirmPrescription from 'Layouts/Main/ConfirmPrescription/ConfirmPrescription';
import ConfirmReplaceMC from 'Layouts/Main/ConfirmReplaceMC/ConfirmReplaceMC';
import MedicalCertModal from 'Modules/MedicalCertificate/MedicalCertModal/MedicalCertModal';
import { MODAL_TYPES } from 'Constants/modal';
import MCDigi from 'Modules/MedicalCertificate/MCDigi/MCDigi';
import MCDigiPreviewModal from 'Modules/MedicalCertificate/MCDigiPreviewModal/MCDigiPreviewModal';
import VirtualBackgroundModal from 'Modules/ZoomContainer/VirtualBackgroundModal/VirtualBackgroundModal';

import AddUser from './AddUser/AddUser';
import AlreadyHaveConsult from './AlreadyHaveConsult/AlreadyHaveConsult';
import PatientInfo from './PatientInfo/PatientInfo';
import CommonModal from './CommonModal/CommonModal';
import EditClinic from './EditClinic/EditClinic';
import WarningModal from './WarningModal/WarningModal';
import ChangePasswordModal from './ChangePasswordModal/ChangePasswordModal';
import RegisterPatient from './RegisterPatient/RegisterPatient';
import Prescription from './Prescription/Prescription';
import Memorandom from './Memorandom/Memorandom';
import PointOfSale from './PointOfSale/PointOfSale';
import ConfirmGoToOnGoingConsult from './ConfirmGoToOnGoingConsult/ConfirmGoToOnGoingConsult';
import PreviewImage from './PreviewImage/PreviewImage';

const ModalMap = {
  alreadyHaveConsult: AlreadyHaveConsult,
  patientInfo: PatientInfo,
  addUser: AddUser,
  editClinic: EditClinic,
  createMemo: CreateMemo,
  referralMemo: ReferralMemo,
  commonModal: CommonModal,
  warningModal: WarningModal,
  prescriptionModal: PrescriptionModal,
  [MODAL_TYPES.CREATE_MC]: MCWrapper,
  posModal: POS,
  changePassword: ChangePasswordModal,
  registerPatient: RegisterPatient,
  prescription: Prescription,
  pointOfSale: PointOfSale,
  memorandom: Memorandom,
  confirmVoidPrescription: ConfirmPrescription,
  virtualBackgroundModal: VirtualBackgroundModal,
  confirmVoidMC: ConfirmReplaceMC,
  [MODAL_TYPES.MANADR_CERT]: MedicalCertModal,
  [MODAL_TYPES.CONFIRM_GO_TO_ON_GOING_CONSULT]: ConfirmGoToOnGoingConsult,
  [MODAL_TYPES.PREVIEW_IMG]: PreviewImage,
  [MODAL_TYPES.DIGI_MC]: MCDigi,
  [MODAL_TYPES.PREVIEW_DIGI_MC]: MCDigiPreviewModal,
};

const CustomModal = () => {
  const { modalList } = useSelector(state => state.modal);
  return modalList.map(e => {
    const Comp = ModalMap[e.type];
    return <Comp data={e.data} key={e.id} id={e.id} fileName={e.fileName} />;
  });
};

export default CustomModal;
